import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { VerskiPraznik } from './verski-praznik';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-verski-praznik-update',
  templateUrl: './verski-praznik-update.component.html'
})
export class VerskiPraznikUpdateComponent
extends BaseUpdateComponent<VerskiPraznik>
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
   }

  ngOnInit() {
    
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'VERSKIPRAZNIK.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'VERSKIPRAZNIK.NAZIV.VALIDATION.MAXLENGTH');
  }

}
